// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import {
  Body1,
  Button,
  Card,
  CardHeader,
  Caption1,
} from "@fluentui/react-components";
import type { ReactNode } from "react";

interface RouteGuardProps {
  isAllowed: boolean;
  title: string;
  description: string;
  actionText: string;
  onAction: () => void;
  children: ReactNode;
}

export function RouteGuard({
  isAllowed,
  title,
  description,
  actionText,
  onAction,
  children,
}: RouteGuardProps) {
  if (isAllowed) {
    return <>{children}</>;
  }

  return (
    <Card className="hero-card">
      <CardHeader
        header={<Body1>{title}</Body1>}
        description={<Caption1>{description}</Caption1>}
      />
      <Button appearance="primary" onClick={onAction}>
        {actionText}
      </Button>
    </Card>
  );
}
